var auditChartInstance = null;

var chart = {

    init: function (labels, passedData, partlyData, failedData) {


        try {
            const ctx = document.getElementById('auditChart');
            if (!ctx) {
                console.error('Chart canvas not found');
                return;
            }

            // Destroy existing chart if it exists
            if (auditChartInstance) {
                auditChartInstance.destroy();
            }

            // Check if Chart is available globally
            if (typeof Chart === 'undefined') {
                console.error('Chart.js library not loaded');
                return;
            }

            auditChartInstance = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: labels.map(label => {
                        // Format date as DD-MM-YYYY for display
                        const date = new Date(`${label}T00:00:00`);
                        return date.toLocaleDateString('nl-NL', {
                            month: 'short',
                            year: 'numeric'
                        });
                    }),
                    datasets: [
                        {
                            label: 'behaalde audits',
                            stack: 'audit-results',
                            data: passedData,
                            backgroundColor: '#67e639',
                            borderColor: '#67e639',
                            borderWidth: 0,
                            borderRadius: 5,
                            borderSkipped: false
                        },
                        {
                            label: 'gedeeltelijk behaalde audits',
                            stack: 'audit-results',
                            data: partlyData,
                            backgroundColor: '#e69039',
                            borderColor: '#e69039',
                            borderWidth: 0,
                            borderRadius: 5,
                            borderSkipped: false
                        },
                        {
                            label: 'niet behaalde audits',
                            stack: 'audit-results',
                            data: failedData,
                            backgroundColor: '#e63946',
                            borderColor: '#e63946',
                            borderWidth: 0,
                            borderRadius: 5,
                            borderSkipped: false
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: true,
                    scales: {
                        x: {
                            stacked: true,
                            title: {
                                display: true,
                                text: 'datum'
                            }
                        },
                        y: {
                            stacked: true,
                            beginAtZero: true,
                            ticks: {
                                stepSize: 1
                            },
                            title: {
                                display: true,
                                text: 'aantal audits'
                            }
                        }
                    },
                    plugins: {
                        legend: {
                            display: false,
                            position: 'top',
                            labels: {
                                usePointStyle: true,
                                padding: 15,
                                font: {
                                    size: 12
                                }
                            }
                        },
                        title: {
                            display: false
                        }
                    }
                }
            });
        } catch (error) {
            console.error('Error initializing chart:', error);
        }
    }
}